import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    isCreatingPostFire: false,
    isCreatingPostFireProject: false,
    showMap: true,

    /* Handles state tracking for BulkEdit component parent and sibling cell edits */
    subRowEditedCells: {
        existingRow: [],
        newRow: [],
        changesSavedToParent: true, // Flag used to block re-setting existing values on multiple sibling edits
    },
    parentRowEditedCells: {
        existingRow: [],
        newRow: [],
    },
};

export const displayStateSlice = createSlice({
    name: 'displayState',
    initialState,
    reducers: {
        setIsCreatingPostFire: (state, action) => {
            state.isCreatingPostFire = action.payload;
        },
        setIsCreatingPostFireProject: (state, action) => {
            state.isCreatingPostFireProject = action.payload;
        },
        setShowMap: (state, action) => {
            state.showMap = action.payload;
        },
        setSubRowEditedCells: (state, action) => {
            state.subRowEditedCells = action.payload;
        },
        setParentRowEditedCells: (state, action) => {
            state.parentRowEditedCells = action.payload;
        },
    },
});

export const {
    setIsCreatingPostFire,
    setIsCreatingPostFireProject,
    setShowMap,
    setSubRowEditedCells,
    setParentRowEditedCells,
} = displayStateSlice.actions;

export default displayStateSlice.reducer;
